import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {WidgetInnerAlertComponent} from '../../widget-inner-alert';

@Component({
    selector: 'widget-order-common-alert',
    templateUrl: 'widget-order-common-alert.component.html',
    styleUrls: ['../../widget-inner-alert/widget-inner-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WidgetOrderCommonAlertComponent
    extends WidgetInnerAlertComponent
    implements OnInit {}
